export default __webpack_public_path__ + "static/media/Group19.79fc4f15.png";